import {ACTION_TYPE} from "utils";

const initialState = {
  drawCall: 0,
};

const mode = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPE.SCENE_INFO:
      return action.payload;
    default:
      return state;
  }
};

export default mode;
